import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { IApiresponse } from "../../_models/common/request-response/apiresponse";
import { Observable } from "rxjs";
import { ClaimsHeaderService } from "../claimsHeader/claims-header.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { first } from "rxjs/operators";
import { LoggingPanelModel, LoggingPanelData, LoggingPanelFilterOption } from "../../_models/common/LoggingPanelModel";
import { LoggingPanelService } from "src/app/_services/logging-panel/logging-panel.service";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { LogObjects } from "../../_models/common/LogObjects";
import { LogObjectActionEnum } from 'src/app/_models';
import { EODDateFormatPipe } from "src/app/_helpers/pipe.module";
import { ExcelExportService } from "src/app/_services/common/excel-export.service";
import { GridComponent } from "../AG-grid/grid-component/grid.component";
import { PanelComponent } from "../design-system/panel/panel.component";
import { TranslateModule } from "@ngx-translate/core";
import { ColDef } from "ag-grid-community";
import { GridConfig } from "../../_models/common/grid/grid-config";
import { ButtonConfig } from "../design-system/button/button.modal";
import { ButtonComponent } from "../design-system/button/button.component";
import { PanelConfig } from "../design-system/panel/panel.modal";

@Component({
    selector: "logging-panel",
    templateUrl: "./logging-panel.component.html",
    styleUrls: ["./logging-panel.component.scss"],
    standalone: true,
    imports: [GridComponent, TranslateModule, ButtonComponent, PanelComponent]
})

export class LoggingPanelComponent implements OnInit {

  loggingPanelModel: LoggingPanelModel;
  title: string;
  btnCancelToolTipText: string;

  dateText: string;
  ActionByText: string;
  claims: Claims;
  ClaimantNameText: string = "";
  LogText: string;
  filterByLabel: string = "";

  logObjects: LogObjects[];
  // allMessages is every log row; messages is what the grid shows (allMessages minus the active filter).
  allMessages: any[] = [];
  messages: any[] = [];
  logObjectActionEnum = LogObjectActionEnum;

  showClaimantColumn: boolean = false;
  filterDropdownList: LoggingPanelFilterOption[] = [];
  selectedFilterText: string = "";

  @ViewChild(GridComponent) gridComponent: GridComponent;
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService,
    private loggingPanelService: LoggingPanelService,
    private eodDate: EODDateFormatPipe,
    private excelExportService: ExcelExportService,
    private claimsService: ClaimsService
  ) {
    this.loggingPanelService.getLogPanelEvent().subscribe((model) => {
        this.openLogPanel(model);
    });
    this.claimsService.currentClaims.subscribe((claims) => (this.claims = claims));
  }

  exportButtonConfig: ButtonConfig = { label: this.translate.instant("label_export"), color: "primary", size: "md" };
  logPanelConfig: PanelConfig = {
    size: 'xl',
    position: 'right',
    hasOverlay: true,
    projectedContent: true
  };
  
  public openLogPanel(model: LoggingPanelModel) {
    this.loggingPanelModel = model;
    if (this.loggingPanelModel) {
      this.title = this.translate.instant("label_log_history");
      this.logPanelConfig= {...this.logPanelConfig, title: this.title };
      this.btnCancelToolTipText = this.translate.instant("close");
      this.dateText = this.translate.instant("date_and_time");
      this.ActionByText = this.translate.instant("action_by");
      this.ClaimantNameText = this.translate.instant("claimant_name");
      this.LogText = this.translate.instant("label_log");
      this.filterByLabel = this.translate.instant("filter_by");
      this.showClaimantColumn = (this.loggingPanelModel.claimantNames?.size ?? 0) > 0;
      this.selectedFilterText = "";
      this.fnBuildFilterDropdownList(this.loggingPanelModel.filterByKeys);
      this.fnCreateColumnDefs();
      this.fnGetGridConfigItems();

      this.getFMActionLog(this.loggingPanelModel.orgId, this.loggingPanelModel.functionId, this.loggingPanelModel.FilterType, this.loggingPanelModel.MileageFilterType, this.loggingPanelModel.EntityFilterType);
    }
  }

  ngOnInit() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
  }

  fnBuildFilterDropdownList(filterByKeys: string[]) {
    this.filterDropdownList = [];
    if (!filterByKeys || filterByKeys.length == 0) {
      return;
    }
    this.filterDropdownList.push(new LoggingPanelFilterOption(this.translate.instant("all"), ""));
    filterByKeys.forEach(key => {
      let label = this.translate.instant(key);
      this.filterDropdownList.push(new LoggingPanelFilterOption(label, label));
    });
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant("date_and_time"),
        field: "Date",
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true,
        flex: 2,
        minWidth: 150,
        cellClass: "text-left",
      },
      {
        headerName: this.translate.instant("action_by"),
        field: "ActionBy",
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true,
        flex: 2,
        minWidth: 150,
        cellClass: "text-left text-truncate",
      },
      {
        headerName: this.translate.instant("label_log"),
        field: "Log",
        sortable: false,
        resizable: true,
        suppressHeaderMenuButton: true,
        flex: this.showClaimantColumn ? 7 : 9,
        minWidth: 300,
        cellClass: "text-left text-truncate",
        cellRenderer: (params: any) => params.value ?? "",
      },
    ];

    if (this.showClaimantColumn) {
      this.gridColumnDefs.splice(2, 0, {
        headerName: this.translate.instant("claimant_name"),
        field: "ClaimantName",
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true,
        flex: 2,
        minWidth: 150,
        cellClass: "text-left text-truncate",
      });
    }
  }

  fnGetGridConfigItems() {
    this.gridConfigItems = new GridConfig(
      false,
      true,
      "sortDate",
      "",
      0,
      false,
      [],
      true,
      true,
      true,
      "",
      "desc",
      40,
      "no_data_available",
      0,
      null,
      false,
      false,
      "",
      "",
      false
    );
    this.gridConfigItems.showFilter = this.filterDropdownList.length > 0;
    this.gridConfigItems.showSearch = this.loggingPanelModel?.showSearch == true;
    this.gridConfigItems.suppressAllFilterOption = true;
  }


  getFMActionLog(orgId: string, functionId: string, FilterType: string, MileageFilterType: string="0", EntityFilterType: string="0") {
    this.allMessages = [];
    this.messages = [];
    this.loggingPanelService.getFMActionLog(orgId, functionId, FilterType, MileageFilterType, EntityFilterType)
      .subscribe((res: any) => {
        this.logObjects = res.responseInfo;
        this.processLogText(this.logObjects);
        this.fnApplyFilter();
        setTimeout(() => {
          this.gridComponent?.refreshGridData();
        }, 100);
      });
}

  processLogText(logObjects: LogObjects[]) {
    logObjects.forEach(logs => {
      let LogDisplayText = this.getLogText(logs);
      if (LogDisplayText.length > 0)
        this.allMessages.push({
          Date: this.eodDate.transform(logs.addOn),
          ActionBy: this.getActionByName(logs.actionByUserName?.toString()),
          ClaimantName: this.getClaimantName(logs.FilterType),
          Log: LogDisplayText.trimEnd(),
          sortDate: logs.addOn ? new Date(logs.addOn).getTime() : 0
        });
      });
  }

  getClaimantName(claimantId: number): string {
    return this.loggingPanelModel?.claimantNames?.get(Number(claimantId)) ?? "";
  }
  
  getActionByName(actionByUserName: string): string {
    if (actionByUserName?.trim()) return actionByUserName;

    const fallback = this.loggingPanelModel?.fallbackActionByName?.trim();
    if (!fallback) return "";
    if (fallback !== "currentUser") return fallback;

    return this.claims?.FinanceManager?.trim()
      || `${this.claims?.FirstName ?? ""} ${this.claims?.LastName ?? ""}`.trim();
  }

  fnOnFilterChange(selectedFilter: any) {
    let selectedName = selectedFilter?.dropdownName ?? selectedFilter;
    let selectedOption = this.filterDropdownList.find(option => option.dropdownName == selectedName);
    this.selectedFilterText = selectedOption ? selectedOption.matchText : "";
    this.fnApplyFilter();
    setTimeout(() => {
      this.gridComponent?.refreshGridData();
    }, 100);
  }

  fnApplyFilter() {
    if (!this.selectedFilterText) {
      this.messages = [...this.allMessages];
      return;
    }
    let filterText = this.selectedFilterText.toLowerCase();
    this.messages = this.allMessages.filter(message =>
      message.Log && message.Log.toLowerCase().includes(filterText));
  }


  getLogText(logs: LogObjects): string {    
    let displayText = this.translate.instant(logs.text.key);
    for (let i = 0; i < logs.text.params.length; i++) {
      if(logs.text.params[i]){
        let parameter = this.translate.instant(logs.text.params[i]);
        displayText = displayText.replace(`{${i}}`, parameter);
      } 
    }
    return displayText;
  }

  dismiss() {
    this.loggingPanelModel = null;
  }

   fnExport(): void {
        const logExport = [];
        let headerRow = [
            this.translate.instant(this.dateText),
            this.translate.instant(this.ActionByText)
        ];
        if (this.showClaimantColumn) {
            headerRow.push(this.translate.instant(this.ClaimantNameText));
        }
        headerRow.push(this.translate.instant(this.LogText));

        logExport.push(headerRow);

        if(this.messages && this.messages.length > 0){
            this.messages.forEach(data => {
                let row = [];
                row.push(data.Date ? data.Date : "");
                row.push(data.ActionBy ? data.ActionBy : "");
                if (this.showClaimantColumn) {
                    row.push(data.ClaimantName ? data.ClaimantName : "");
                }
                row.push(data.Log ? this.fnConvertHtmlToText(data.Log ): "");
                logExport.push(row);
            });
        }
        this.excelExportService.exportToCsv("LogExport.csv", logExport);
    }

 fnConvertHtmlToText(html: string): string {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || '';
}

}
